import { memo } from "react";

import InteractiveColumn, {
  TableHeadInteractiveColumnProps,
} from "ds/components/Table/Head/InteractiveColumn";
import { TableColumnMeta } from "ds/components/Table/types";

import { SelectAllOption } from "../Table/types";
import { TableSimpleSelectionStore, TableSimpleStore } from "./types";

type TableSimpleHeadColumnProps = {
  column: TableColumnMeta;
  store: TableSimpleStore;
  selectionStore?: TableSimpleSelectionStore;
  selectionOptions?: SelectAllOption[];
} & Pick<
  TableHeadInteractiveColumnProps,
  | "stickyLeft"
  | "stickyRight"
  | "children"
  | "tableRef"
  | "analyticsPage"
  | "filtersStorageKey"
  | "sortCallback"
  | "sortConfig"
  | "isLast"
  | "externalSortManagement"
  | "isPinningEnabled"
>;

const TableSimpleHeadColumn = ({
  column,
  store,
  selectionStore,
  selectionOptions,
  externalSortManagement,
  stickyLeft,
  stickyRight,
  children,
  tableRef,
  analyticsPage,
  filtersStorageKey,
  sortCallback,
  sortConfig,
  isLast,
  isPinningEnabled,
}: TableSimpleHeadColumnProps) => {
  return (
    <InteractiveColumn
      column={column}
      store={store}
      selectionStore={selectionStore}
      selectionOptions={selectionOptions}
      stickyLeft={stickyLeft}
      stickyRight={stickyRight}
      analyticsPage={analyticsPage}
      filtersStorageKey={filtersStorageKey}
      tableRef={tableRef}
      sortCallback={sortCallback}
      sortConfig={sortConfig}
      isLast={isLast}
      externalSortManagement={externalSortManagement}
      isPinningEnabled={isPinningEnabled}
    >
      {children}
    </InteractiveColumn>
  );
};

TableSimpleHeadColumn.displayName = "DS.TableSimple.HeadColumn";

export default memo(TableSimpleHeadColumn);
